<template>
  <div class="ficha-mapa ficha-vegetacion">
    <div class="encabezado">Vegetación</div>
    <div class="contenedor">
      <Carousel
        class="oculto-escritorio"
        :altura="300"
        :id="'carrusel-avistamiento'"
        :lista="lista_fotos"
      />

      <div class="col">
        <div class="ficha">
          <div class="ficha-foto oculto-movil">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha7/1_Matorrales.jpg"
              alt=""
            />
            <div class="degradado-vegetacion"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Matorrales</p>
          </div>
          <div class="ficha-cuerpo">
            <ul>
              <li>
                En la Región Nororiente de la Cuenca de México (RNOCM), la
                vegetación (que incluye formaciones de bosques de encino, pino,
                oyamel, mixto de pino encino, de táscate, cultivado, matorrales
                y vegetación riparia) de tipo secundaria ocupa el 12% de la
                superficie, mientras que la primaria el 10%.
              </li>
              <li>
                En la RNOCM se encuentran
                <strong>37 áreas naturales protegidas,</strong> que en total
                cubren una superficie de 96 mil 955.6 ha, lo que representa
                15.2% del total del área de estudio.
              </li>
              <li>
                <strong
                  >En la porción del Estado de México, la vegetación primaria
                  perdió 25 mil ha, </strong
                >principalmente, debido a proyectos de infraestructura, avance
                de la frontera agrícola (pese a que se reporta decremento) y
                crecimiento de los bancos de materiales.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="ficha-espacio"></div>

      <div class="col">
        <div class="ficha-foto oculto-movil ficha-foto-full-height">
          <img
            class="foto"
            src="@/assets/fichas-diagnostico/ficha7/2_Mexquitales.jpg"
            alt=""
          />
          <div class="degradado-vegetacion"></div>
          <div class="cuadro-contraste"></div>
          <p class="pie-foto">Mezquitales</p>
        </div>
      </div>

      <div class="ficha-espacio"></div>

      <div class="col">
        <div class="ficha-foto oculto-movil ficha-foto-half-height">
          <img
            class="foto"
            src="@/assets/fichas-diagnostico/ficha7/3_Pastizales.jpg"
            alt=""
          />
          <div class="degradado-vegetacion"></div>
          <div class="cuadro-contraste"></div>
          <p class="pie-foto">Pastizales</p>
        </div>
        <div class="ficha-foto oculto-movil ficha-foto-half-height">
          <img
            class="foto"
            src="@/assets/fichas-diagnostico/ficha7/4-CiénegaSanJuan.jpg"
            alt=""
          />
          <div class="degradado-vegetacion"></div>
          <div class="cuadro-contraste"></div>
          <p class="pie-foto">Ciénega de San Juan</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from "@/components/base/Carousel.vue";

export default {
  name: "Vegetacion",
  components: {
    Carousel,
  },
  data() {
    return {
      lista_fotos: [
        [
          require("@/assets/fichas-diagnostico/ficha7/1_Matorrales.jpg"),
          "Matorrales",
        ],
        [
          require("@/assets/fichas-diagnostico/ficha7/2_Mexquitales.jpg"),
          "Mezquitales",
        ],
        [
          require("@/assets/fichas-diagnostico/ficha7/3_Pastizales.jpg"),
          "Pastizales",
        ],
        [
          require("@/assets/fichas-diagnostico/ficha7/4-CiénegaSanJuan.jpg"),
          "Ciénega de San Juan",
        ],
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
@media (min-width: map-get($media-queries-limit, "mobile")) {
  div.oculto-escritorio {
    display: none;
  }
  div.oculto-movil {
    display: inherit;
  }
}
@media (max-width: map-get($media-queries-limit, "mobile")) {
  div.oculto-escritorio {
    display: inherit;
  }
  div.oculto-movil {
    display: none;
  }
}
.carrusel-cuerpo {
  padding: 0 30px;
}
</style>